export default __webpack_public_path__ + "static/media/export.fc65fdb6.svg";